import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";
import VideoCard from "@/components/feature/VideoCard";

type Props = {
  title: string;
  subtitle: string;
  icon: string;
  videos: Video[];
  viewAllTo?: string;
  viewAllLabel?: string;
};

export default function VideoSection({
  title,
  subtitle,
  icon,
  videos,
  viewAllTo,
  viewAllLabel = "查看更多",
}: Props) {
  return (
    <section className="px-4 pt-10 md:px-6 md:pt-14">
      <div className="mb-5 flex items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
            <i className={`${icon} text-xl`}></i>
          </span>
          <div>
            <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
              {title}
            </h2>
            <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
          </div>
        </div>
        {viewAllTo && (
          <Link
            to={viewAllTo}
            className="hidden items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm font-label text-primary-600 transition-colors duration-200 hover:bg-primary-100 sm:flex"
          >
            {viewAllLabel}
            <i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        )}
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 md:gap-4">
        {videos.map((v) => (
          <VideoCard key={v.id} video={v} />
        ))}
      </div>
      {viewAllTo && (
        <div className="mt-5 flex justify-center sm:hidden">
          <Link
            to={viewAllTo}
            className="inline-flex items-center gap-1 rounded-md border border-background-200 px-4 py-2 text-sm font-label text-primary-600"
          >
            {viewAllLabel}
            <i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        </div>
      )}
    </section>
  );
}